import React from "react";
import PropTypes from "prop-types";
import Dropdown from "react-bootstrap/Dropdown";
import styled from "styled-components";
import Image from "react-bootstrap/Image";

import SettingsIcon from "../../../Icons/Settings";
import useWidthHook from "../../../Hooks/useWidth";
import ChevronIcon from "../../../Icons/Chevron";
import LogoutIcon from "../../../Icons/Logout";
import UserIcon from "../../../Icons/User";

const propTypes = {
  /**
   * The user object.
   */
  user: PropTypes.shape({
    name: PropTypes.string,
    photo: PropTypes.string
  }),
  /**
   * The function to be called when the settings dropdown item is clicked.
   */
  settings: PropTypes.func,
  /**
   * The function to be called when the logout dropdown item is clicked.
   */
  logout: PropTypes.func,
  /**
   * The function to be called when the profile dropdown item is clicked.
   */
  profile: PropTypes.func
};

const ProfileDropdown = ({ user, profile, settings, logout }) => {
  /**
   * hooks
   */
  const width = useWidthHook();

  return (
    <Dropdown>
      <Toggle
        aria-label="Profile dropdown"
        className="d-flex cursor-pointer align-items-center px-0 p-md-1 gap-2"
      >
        <Image
          alt="User Profile Picture"
          className="img-fit rounded-circle bg-gray"
          src={user?.photo || process.env.REACT_APP_PLACEHOLDER_PROFILE_IMAGE}
        />
        {width >= 768 && (
          <span className="d-flex align-items-center">
            <small className="text-capitalize">
              {user?.name && user?.name?.split(" ")[0]?.toLowerCase()}
            </small>
            <ChevronIcon direction="down" />
          </span>
        )}
      </Toggle>
      <Menu className="py-0">
        <div className="px-4 py-8 bg-gray-10 d-flex align-items-center gap-4 mb-2">
          <div>
            <Image
              alt="User Profile Picture"
              style={{ width: 48, height: 48 }}
              className="img-fit rounded-circle bg-gray"
              src={
                user?.photo || process.env.REACT_APP_PLACEHOLDER_PROFILE_IMAGE
              }
            />
          </div>
          <div>
            <p className="fw-bold text-capitalize">
              {user?.name?.toLowerCase() || ""}
            </p>
          </div>
        </div>

        {profile && (
          <Item onClick={profile}>
            <UserIcon variant="outline" />
            <span>Your profile</span>
          </Item>
        )}

        {settings && (
          <Item onClick={settings}>
            <SettingsIcon variant="outline" />
            <span>Account Settings</span>
          </Item>
        )}

        {logout && (settings || profile) && <Dropdown.Divider />}

        {logout && (
          <Item onClick={logout}>
            <LogoutIcon variant="outline" />
            <span>Logout</span>
          </Item>
        )}
      </Menu>
    </Dropdown>
  );
};

/**
 * style
 */
const Item = styled(Dropdown.Item)`
  gap: 1rem;
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
`;

const Menu = styled(Dropdown.Menu)`
  padding: 0;
  z-index: 1;
  min-width: 20rem;

  & > *:not(:last-child) {
    margin-bottom: 0.5rem;
  }
`;

const Toggle = styled(Dropdown.Toggle)`
  img {
    width: 2rem;
    height: 2rem;
  }

  @media (min-width: 768px) {
    border-radius: 2rem;
    background-color: #fff;
  }
`;

ProfileDropdown.propTypes = propTypes;

export default ProfileDropdown;
